import { conformToMask } from 'vue-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default {
  name: 'PercentageMask',

  data() {
    return {
      numberMask: createNumberMask({
        prefix: '',
        suffix: '',
        allowDecimal: true,
        allowNegative: true,
        includeThousandsSeparator: false,
        decimalSymbol: ',',
        decimalLimit: 2,
      }),
    };
  },
  methods: {
    addDecimalMask(value) {
      if (value === null || value === undefined || value === '') return '';
      const val = Number(value).toFixed(2).replace('.', ',');
      const conformed = conformToMask(val, this.numberMask, { guide: false });
      return conformed.conformedValue;
    },
    removeDecimalMask(value) {
      if (!value || value === '-' || value === ',') return null;
      const parsed = parseFloat(value.replace(',', '.'));
      return Number.isNaN(parsed) ? null : parsed;
    },
  },
};
